var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { twMerge } from 'tailwind-merge';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
export const PointsFAQLink = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return (<div className={twMerge('flex gap-1 items-center', className)} {...rest}>
			<a href="https://daredrop.com/points-program" target="_blank" rel="noopener noreferrer" className="text-xs underline text-light-3 hover:brightness-75">Learn more about points</a>
			<InfoOutlineIcon className="!fill-primary" fontSize="small"/>
		</div>);
};
